// Lazy, memoised loader for bwip-js (~950 KiB). Keeping it out of the static
// import graph means a generator route's initial bundle no longer ships the
// whole barcode engine — it loads once, on first render (right after the page
// paints), and every later call reuses the same module.
//
// bwip-js/browser is CJS; the callable API (toCanvas/toSVG/…) lives on the
// module object itself, which is what the previous `import bwipjs from
// "bwip-js/browser"` default import resolved to under esModuleInterop.
type Bwip = typeof import("bwip-js/browser");

let promise: Promise<Bwip> | null = null;

export function loadBwip(): Promise<Bwip> {
  if (!promise) {
    promise = import("bwip-js/browser").then(
      (m) => (m as { default?: Bwip }).default ?? m,
    );
  }
  return promise;
}
